var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOverlayChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 61,
    viewBox: "0 0 92 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7082_300485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.4904 8H4.20064C3.12117 8 2.24609 8.87508 2.24609 9.95455V49.0455C2.24609 50.1249 3.12117 51 4.20064 51H88.4904C89.5699 51 90.445 50.1249 90.445 49.0455V9.95455C90.445 8.87508 89.5699 8 88.4904 8Z",
    fill: "#4F4C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4904 8H4.20064C3.12117 8 2.24609 8.87508 2.24609 9.95455V49.0455C2.24609 50.1249 3.12117 51 4.20064 51H88.4904C89.5699 51 90.445 50.1249 90.445 49.0455V9.95455C90.445 8.87508 89.5699 8 88.4904 8Z",
    fill: "#4F4C57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "black-triangle",
    d: "M42.561 34.2288C42.8067 34.2288 43.0154 34.1364 43.2611 34.0037L50.4206 30.113C50.9304 29.8302 51.1083 29.6455 51.1083 29.3395C51.1083 29.0336 50.9304 28.8488 50.4206 28.5718L43.2611 24.6754C43.0154 24.5426 42.8067 24.4561 42.561 24.4561C42.1066 24.4561 41.8242 24.7793 41.8242 25.2815V33.3976C41.8242 33.8997 42.1066 34.2288 42.561 34.2288Z",
    fill: "#312F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0043 27.5449H83.1179C82.5782 27.5449 82.1406 27.9825 82.1406 28.5222C82.1406 29.0619 82.5782 29.4995 83.1179 29.4995H88.0043C88.544 29.4995 88.9815 29.0619 88.9815 28.5222C88.9815 27.9825 88.544 27.5449 88.0043 27.5449Z",
    id: "black-triangle",
    fill: "#312F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0014 31.4541H81.6491C81.1094 31.4541 80.6719 31.8916 80.6719 32.4314C80.6719 32.9711 81.1094 33.4086 81.6491 33.4086H88.0014C88.5412 33.4086 88.9787 32.9711 88.9787 32.4314C88.9787 31.8916 88.5412 31.4541 88.0014 31.4541Z",
    id: "black-triangle",
    fill: "#312F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 35.3633H78.2273C77.6875 35.3633 77.25 35.8008 77.25 36.3406C77.25 36.8803 77.6875 37.3178 78.2273 37.3178H88C88.5397 37.3178 88.9773 36.8803 88.9773 36.3406C88.9773 35.8008 88.5397 35.3633 88 35.3633Z",
    id: "black-triangle",
    fill: "#312F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9979 39.2725H81.157C80.6172 39.2725 80.1797 39.71 80.1797 40.2497C80.1797 40.7895 80.6172 41.227 81.157 41.227H87.9979C88.5376 41.227 88.9751 40.7895 88.9751 40.2497C88.9751 39.71 88.5376 39.2725 87.9979 39.2725Z",
    id: "black-triangle",
    fill: "#312F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9964 43.1816H83.1101C82.5704 43.1816 82.1328 43.6192 82.1328 44.1589C82.1328 44.6986 82.5704 45.1362 83.1101 45.1362H87.9964C88.5362 45.1362 88.9737 44.6986 88.9737 44.1589C88.9737 43.6192 88.5362 43.1816 87.9964 43.1816Z",
    id: "black-triangle",
    fill: "#312F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9989 47.0908H79.6921C79.1524 47.0908 78.7148 47.5284 78.7148 48.0681C78.7148 48.6078 79.1524 49.0454 79.6921 49.0454H87.9989C88.5387 49.0454 88.9762 48.6078 88.9762 48.0681C88.9762 47.5284 88.5387 47.0908 87.9989 47.0908Z",
    id: "black-triangle",
    fill: "#312F38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7082_300485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.9318,
    height: 43,
    fill: "white",
    transform: "translate(2 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOverlayChat);
export default __webpack_public_path__ + "static/media/icon-overlay-chat.6fcbb4110afbdad796d6ab48ca922a5f.svg";
export { ForwardRef as ReactComponent };